import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import logger from 'redux-logger';

import assistantReducer from "./slices/assistantSlice";
import dialogReducer from "./slices/dialogSlice";
import integrationReducer from "./slices/integrationSlice";
import modelReducer from "./slices/modelSlice";
import userReducer from "./slices/userSlice";
import widgetReducer from "./slices/widgetSlice";
import avitoReducer from "./slices/avitoSlice";
import vkReducer from "./slices/vkSlice";
import billingReducer from "./slices/billingSlice";
import dialogWFReducer from "./slices/dialogFormWidgetSlice";
import assistantWFReducer from "./slices/asistantWFSlice";
import bitrixChatBotReducer from "./slices/bitrixChatBotSlice";
import googleSheetsReducer from "./slices/googleSheetsSlice";
import rentProgReducer from "./slices/rentProgSlice";
import amoSlice from "./slices/amoSlice";
import employeesReducer from "./slices/employeesSlice";
import customSelectReducer from "./slices/customSelectSlice";
import instructionReducer from "./slices/instructionsSlice";

import { tokenMiddleware } from "../middleware/tokenMiddleware";

const appReducer = combineReducers({
  user: userReducer,
  dialog: dialogReducer,
  model: modelReducer,
  assistant: assistantReducer,
  integration: integrationReducer,
  widget: widgetReducer,
  avito: avitoReducer,
  vk: vkReducer,
  billing: billingReducer,
  dialogWF: dialogWFReducer,
  assistantWF: assistantWFReducer,
  bitrixChatBot: bitrixChatBotReducer,
  googleSheets: googleSheetsReducer,
  rentProg: rentProgReducer,
  employees: employeesReducer,
  amo: amoSlice,
  customSelect: customSelectReducer,
  instruction: instructionReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "reset") {
    state = undefined;
  }
  return appReducer(state, action);
};

const preloadedState = {};
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // <--- добавь вот это
    }).concat(tokenMiddleware),
  preloadedState,
});

export default store;
